var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E66910",
    d: "M13,13c0-0.552-0.448-1-1-1H5c-0.552,0-1,0.448-1,1v11 c0,0.553,0.448,1,1,1h7c0.552,0,1-0.447,1-1V13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#34B5C7",
    d: "M29,8H3C2.448,8,2,8.448,2,9v14c0,0.553,0.448,1,1,1V13 c0-1.104,0.896-2,2-2h7c1.104,0,2,0.896,2,2v11h15c0.553,0,1-0.447,1-1V9C30,8.448,29.553,8,29,8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#413A4D",
    d: "M6.747,20.094l-0.968-0.248l-0.996,3.873l3.874,0.996l0.25-0.968 l-2.221-0.571L13,19.444v-1.162l-6.824,4.032L6.747,20.094z M29,6H3C1.343,6,0,7.343,0,9v14c0,1.573,1.217,2.851,2.759,2.976 C3.309,26.599,4.104,27,5,27h7c0.885,0,1.672-0.391,2.221-1H29c1.656,0,3-1.344,3-3V9C32,7.343,30.656,6,29,6z M14,24 c0,1.104-0.896,2-2,2H5c-1.104,0-2-0.896-2-2V13c0-1.104,0.896-2,2-2h7c1.104,0,2,0.896,2,2V24z M31,23c0,1.104-0.896,2-2,2 H14.816C14.928,24.686,15,24.353,15,24v-5.737l12.824-7.578l-0.57,2.221l0.968,0.249l0.996-3.874l-3.874-0.997l-0.249,0.969 l2.221,0.571L15,17.101V13c0-1.657-1.343-3-3-3H5c-1.657,0-3,1.343-3,3v11c0,0.273,0.049,0.534,0.117,0.786 C1.458,24.459,1,23.786,1,23V9c0-1.104,0.896-2,2-2h26c1.104,0,2,0.896,2,2V23z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.78ff27183d96770c1363724fd3e3c4ee.svg";
export { ForwardRef as ReactComponent };